import useContextWithErrorHandler from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { SoundOutWordsContext } from '../providers/SoundOutWordsProvider';
import { UseSoundOutWords } from '../providers/SoundOutWordsProvider/types';

export const useSoundOutWords = (): UseSoundOutWords => {
  const [state, dispatch] = useContextWithErrorHandler(
    SoundOutWordsContext,
    'SoundOutWordsProvider'
  );
  return [state, dispatch];
};
